import { Outlet } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { SidebarPatientV2 } from "@/components/menu/SidebarPatientV2";

export default function Patient() {
  return (
    <SidebarProvider>
    <SidebarPatientV2 />
    <main className="w-full">
      <Outlet />
    </main>
  </SidebarProvider>
  );
}
